import { Component, Input } from '@angular/core';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-text-filter',
  standalone: true,
  imports: [MatFormField, MatInput, MatLabel, ReactiveFormsModule, MatSuffix, MatError],
  templateUrl: './text-filter.component.html',
  styleUrl: './text-filter.component.scss'
})
export class TextFilterComponent {
  @Input() paramsGroup!: FormGroup;
}
